// TODO : Description Jadiin 2
// TODO : Still HARDCODE Transaction Type
<style>
    .large-popup .vs-popup {
        width: 1000px;
    }
</style>
<template>
    <div>
        <vs-card class="p-4">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Add New Stock Transfer</h4>
                </div>
                <vs-button
                    color="primary"
                    class="btn mb-4 md:mb-0 mr-1"
                    @click="submitForm"
                    :disabled="data.details.length < 1"
                >Save</vs-button>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Transfer ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Posting Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.date"/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Transaction Type*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.transaction_type_id"
                                width="100%"
                                autocomplete
                                @input="handleTransactionTypeChange"
                                :disabled="data.details.length > 0"
                            >
                                <vs-select-item v-for="(item, index) in transaction_types" :key="index" :value="item.value" :text="item.label"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" disabled v-model="data.transaction_description"/>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details" class="pt-base">
                    <vs-button class="mr-4" type="border" @click="initShowDetail" :disabled="!data.transaction_type_id">Add</vs-button>
                    <vs-button type="border" :disabled="data.details.length < 1" @click="removeLine">Remove</vs-button>
                    <vs-table v-model="selected" :data="data.details" hoverFlat class="mt-base" multiple>
                        <template slot="thead">
                            <vs-th>Line ID</vs-th>
                            <vs-th>Line Type</vs-th>
                            <vs-th>Warehouse ID</vs-th>
                            <vs-th>Client ID</vs-th>
                            <vs-th>Product ID</vs-th>
                            <vs-th>Description</vs-th>
                            <vs-th>Pack ID</vs-th>
                            <vs-th>Batch</vs-th>
                            <vs-th>Exp. Date</vs-th>
                            <vs-th>Base Qty</vs-th>
                            <vs-th>Base UoM</vs-th>
                            <vs-th>Stock Type</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>{{ tr.line_id }}</vs-td>
                                <vs-td>{{ tr.line_type }}</vs-td>
                                <vs-td>{{ tr.warehouses_code }}</vs-td>
                                <vs-td>{{ tr.client_code }}</vs-td>
                                <vs-td>{{ tr.product_code }}</vs-td>
                                <vs-td style="max-width: 200px; text-overflow: ellipsis; overflow: hidden;">{{ tr.description }}</vs-td>
                                <vs-td>{{ tr.pack_id }}</vs-td>
                                <vs-td>{{ tr.batch }}</vs-td>
                                <vs-td>{{ tr.expired_date }}</vs-td>
                                <vs-td>{{ tr.base_qty }}</vs-td>
                                <vs-td>{{ tr.base_uom }}</vs-td>
                                <vs-td>{{ tr.stock_type }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
                <vs-tab label="Notes" class="pt-base">
                    <vs-textarea label="Note" height="200" v-model="data.note"/>
                </vs-tab>
                <vs-tab label="Attachment" class="pt-base">
                    <vs-row class="w-full">
                        <vs-button class="mr-4" type="border">Add</vs-button>
                        <vs-button class="mr-4" type="border">Remove</vs-button>
                    </vs-row>
                </vs-tab>
            </vs-tabs>
        </vs-card>

        <!-- Popup Details -->
        <vs-popup
            title="Stock Transfer Details"
            :active.sync="showDetailPopup"
            class="large-popup"
            @close="showDetailPopup = true"
        >
            <div class="vx-row mb-3">
                <div class="vx-col w-1/2">
                    <p class="mb-base"><b>Source</b></p>
                    <div class="vx-col w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Warehouse ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="source.warehouse_id"
                                    width="100%"
                                    autocomplete
                                    @input="handleWarehouseChange"
                                    :disabled="disableSource.warehouse"
                                >
                                    <vs-select-item v-for="(item, index) in warehouses" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Client ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="source.client_id"
                                    width="100%"
                                    autocomplete
                                    @input="handleClientChange(source.client_id)"
                                    :disabled="disableSource.client"
                                >
                                    <vs-select-item v-for="(item, index) in clients" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Product ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="source.product_id"
                                    width="100%"
                                    autocomplete
                                    @input="handleProductChange(source)"
                                    :disabled="disableSource.product"
                                >
                                    <vs-select-item v-for="(item, index) in products" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Description
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" disabled v-model="source.description_1"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" disabled v-model="source.description_2"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Pack ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="source.pack_id" :disabled="disableSource.pack_id" @input="(data.transaction_type == 'TST') ? destination.pack_id = source.pack_id : ''"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Batch
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="source.batch" :disabled="disableSource.batch" @input="(data.transaction_type == 'TST') ? destination.batch = source.batch : ''"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Expired Date
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="source.expired_date" :disabled="disableSource.expired_date" @input="(data.transaction_type == 'TST') ? destination.expired_date = source.expired_date : ''"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Qty
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-input class="w-full" v-model="source.qty" @input="convertQty(source)" @change="isNumber($event)" :disabled="disableSource.qty"/>
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="source.uom_id"
                                    width="100%"
                                    autocomplete
                                    @input="handeUomChange(source)"
                                    :disabled="disableSource.uom"
                                >
                                    <vs-select-item v-for="(item, index) in source.uoms" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Base Qty
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-input class="w-full" disabled v-model="source.base_qty"/>
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="source.base_uom_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in source.uoms" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Stock Type
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="source.stock_type_id"
                                    width="100%"
                                    autocomplete
                                    :disabled="disableSource.stock_type"
                                >
                                    <vs-select-item v-for="(item, index) in stock_types" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-1/2">
                    <p class="mb-base"><b>Destination</b></p>
                    <div class="vx-col w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Warehouse ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="destination.warehouse_id"
                                    width="100%"
                                    autocomplete
                                    :disabled="disableDestination.warehouse"
                                >
                                    <vs-select-item v-for="(item, index) in warehouses" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Client ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="destination.client_id"
                                    width="100%"
                                    autocomplete
                                    @input="handleClientChange(destination.client_id)"
                                    :disabled="disableDestination.client"
                                >
                                    <vs-select-item v-for="(item, index) in clients" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Product ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="destination.product_id"
                                    width="100%"
                                    autocomplete
                                    @input="handleProductChange(destination)"
                                    :disabled="disableDestination.product"
                                >
                                    <vs-select-item v-for="(item, index) in products" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Description
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" disabled v-model="destination.description_1"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" disabled v-model="destination.description_2"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Pack ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="destination.pack_id" :disabled="disableDestination.pack_id"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Batch
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="destination.batch" :disabled="disableDestination.batch"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Expired Date
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="destination.expired_date" :disabled="disableDestination.expired_date"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Qty
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-input class="w-full" v-model="destination.qty" @input="convertQty(destination)" @change="isNumber($event)" :disabled="disableDestination.qty"/>
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="destination.uom_id"
                                    width="100%"
                                    autocomplete
                                    @input="handeUomChange(destination)"
                                    :disabled="disableDestination.uom"
                                >
                                    <vs-select-item v-for="(item, index) in destination.uoms" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Base Qty
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-input class="w-full" disabled v-model="destination.base_qty"/>
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="destination.base_uom_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in destination.uoms" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Stock Type
                            </div>
                            <div class="vx-col w-1/3">
                                <vs-select
                                    class="selectExample mb-3"
                                    v-model="destination.stock_type_id"
                                    width="100%"
                                    autocomplete
                                    :disabled="disableDestination.stock_type"
                                >
                                    <vs-select-item v-for="(item, index) in stock_types" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                <vs-button color="primary" class="mr-2" @click="validateData">Save</vs-button>
                <vs-button color="primary" type="flat" @click="showDetailPopup = false">Cancel</vs-button>
            </vs-row>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            selected: [],
            disableDestination: {
                state: true,
                warehouse: true,
                client: true,
                product: true,
                pack_id: true,
                batch: true,
                expired_date: true,
                qty: true,
                uom: true,
                stock_type: true
            },
            disableSource: {
                state: true,
                warehouse: true,
                client: true,
                product: true,
                pack_id: true,
                batch: true,
                expired_date: true,
                qty: true,
                uom: true,
                stock_type: true
            },
            showDetailPopup: false,
            isLoading: false,
            data: {
                id: '',
                reference: '',
                date: new Date(),
                transaction_type_id: null,
                transaction_description: '',
                details: []
            },
            type: '',
            source: {
                warehouse_id: null,
                client_id: null,
                product_id: null,
                uom_id: null,
                base_uom_id: null,
                stock_type_id: null,
                description_1: '',
                description_2: '',
                pack_id: '',
                batch: '',
                expired_date: '',
                qty: '',
                base_qty: '',
                numerator: '',
                denominator: '',
                uoms: []
            },
            destination: {
                warehouse_id: null,
                client_id: null,
                product_id: null,
                uom_id: null,
                base_uom_id: null,
                stock_type_id: null,
                description_1: '',
                description_2: '',
                pack_id: '',
                batch: '',
                expired_date: '',
                qty: '',
                base_qty: '',
                numerator: '',
                denominator: '',
                uoms: []
            },

            // Dropdowns
            transaction_types: [],
            warehouses: [],
            clients: [],
            stock_types: [],
            products: [],
            moData: []
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
    },
    methods: {
        back() {
            this.$router.push({name: 'stock-transfer'})
        },
        submitForm() {
            const data = {
                stock_transfer: {
                    reference: this.data.reference,
                    posting_date: this.data.date,
                    transaction_type_id: this.data.transaction_type_id,
                },
                stock_transfer_details: this.data.details.map(item => {
                    return {
                        line_id: item.line_id,
                        line_type: item.line_type,
                        warehouse_id: item.warehouse_id,
                        client_id: item.client_id,
                        product_id: item.product_id,
                        pack_id: item.pack_id,
                        batch: item.batch,
                        expired_date: item.expired_date,
                        base_qty: item.base_qty,
                        stock_type_id: item.stock_type_id,
                    }
                })
            }

            this.isLoading = true
            this.$http.post('inventories/stocktransfer/store', data)
            .then(res => {
                this.isLoading = false
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: 'Stock transfer added successfully.'
                });

                this.$router.push({
                    name: 'stock-transfer-view',
                    params: {
                        id: res.data.id
                    }
                })
            })
            .catch(error => this.handleError(error))

            console.log(data)
        },
        initShowDetail() {
            this.showDetailPopup = true
            this.disableAll()

            if(this.data.transaction_type_id == 1) {
                this.disableDestination.state = false
                this.disableDestination.warehouse = false
                this.disableDestination.client = false
                this.disableDestination.product = false
                this.disableDestination.pack_id = false
                this.disableDestination.batch = false
                this.disableDestination.expired_date = false
                this.disableDestination.qty = false
                this.disableDestination.uom = false
                this.disableDestination.stock_type = false
                
                this.destination.warehouse_id = this.$store.state.user.userconfig.warehouses.id
                this.destination.client_id = this.$store.state.user.userconfig.clients.id
                this.destination.stock_type_id = this.$store.state.user.userconfig.stock_type.id
            }
            else if(this.data.transaction_type_id == 2) {
                this.disableSource.state = false
                this.disableSource.warehouse = false
                this.disableSource.client = false
                this.disableSource.product = false
                this.disableSource.pack_id = false
                this.disableSource.batch = false
                this.disableSource.expired_date = false
                this.disableSource.qty = false
                this.disableSource.uom = false
                this.disableSource.stock_type = false

                this.source.warehouse_id = this.$store.state.user.userconfig.warehouses.id
                this.source.client_id = this.$store.state.user.userconfig.clients.id
                this.source.stock_type_id = this.$store.state.user.userconfig.stock_type.id
            }
            else if(this.data.transaction_type_id == 3) {
                this.disableSource.state = false
                this.disableSource.warehouse = false
                this.disableSource.client = false
                this.disableSource.product = false
                this.disableSource.pack_id = false
                this.disableSource.batch = false
                this.disableSource.expired_date = false
                this.disableSource.qty = false
                this.disableSource.stock_type = false

                this.source.warehouse_id = this.$store.state.user.userconfig.warehouses.id
                this.source.client_id = this.$store.state.user.userconfig.clients.id
                this.source.stock_type_id = this.$store.state.user.userconfig.stock_type.id

                this.disableDestination.state = false
                this.disableDestination.product = false
                this.disableDestination.pack_id = false
                this.disableDestination.batch = false
                this.disableDestination.expired_date = false
                this.disableDestination.qty = false
                this.disableDestination.stock_type = false

                this.destination.warehouse_id = this.$store.state.user.userconfig.warehouses.id
                this.destination.client_id = this.$store.state.user.userconfig.clients.id
                this.destination.stock_type_id = this.$store.state.user.userconfig.stock_type.id
            }
            else if(this.data.transaction_type_id == 4) {
                this.disableSource.state = false
                this.disableSource.warehouse = false
                this.disableSource.client = false
                this.disableSource.product = false
                this.disableSource.pack_id = false
                this.disableSource.batch = false
                this.disableSource.expired_date = false
                this.disableSource.qty = false
                this.disableSource.uom = false
                this.disableSource.stock_type = false

                this.source.warehouse_id = this.$store.state.user.userconfig.warehouses.id
                this.source.client_id = this.$store.state.user.userconfig.clients.id
                this.source.stock_type_id = this.$store.state.user.userconfig.stock_type.id

                this.disableDestination.state = false
                this.disableDestination.stock_type = false
                this.destination.warehouse_id = this.$store.state.user.userconfig.warehouses.id
                this.destination.client_id = this.$store.state.user.userconfig.clients.id
                this.destination.stock_type_id = this.$store.state.user.userconfig.stock_type.id
            }
            else if(this.data.transaction_type_id == 5) {
                this.disableSource.state = false
                this.disableSource.warehouse = false
                this.disableSource.client = false
                this.disableSource.product = false
                this.disableSource.pack_id = false
                this.disableSource.batch = false
                this.disableSource.expired_date = false
                this.disableSource.qty = false
                this.disableSource.uom = false
                this.disableSource.stock_type = false

                this.disableDestination.state = false
                this.disableDestination.client = false
                this.source.warehouse_id = this.$store.state.user.userconfig.warehouses.id
                this.source.client_id = this.$store.state.user.userconfig.clients.id
            }

            if(this.source.client_id) {
                this.handleClientChange(this.source.client_id)
            }
            else if (this.destination.client_id) {
                this.handleClientChange(this.destination.client_id)
            }
        },
        convertQty(data) {
            data.base_qty = (data.qty / data.denominator) * data.numerator
            if(this.data.transaction_type_id == 4) {
                this.destination.qty = this.source.qty
                this.destination.base_qty = this.source.base_qty
            }
        },
        validateData() {
            this.isLoading = true
            const data = {}

            if(!this.disableDestination.state) {
                data.destination = this.destination
            }


            if(!this.disableSource.state) {
                data.source = this.source
            }

            this.$http.post('inventories/stocktransfer/validation', data)
            .then(res => {
                this.isLoading = false
                let line_id = this.generateLineId()
                let destination = {}
                let source = {}
                
                if(!this.disableSource.state) {
                    source = {
                        line_id: line_id,
                        line_type: 'S',
                        warehouse_id: this.source.warehouse_id,
                        warehouses_code: this.warehouses[this.warehouses.findIndex(w => w.value == this.source.warehouse_id)].label,
                        client_id: this.source.client_id,
                        client_code: this.clients[this.clients.findIndex(c => c.value == this.source.client_id)].label,
                        product_id: this.source.product_id,
                        product_code: this.products[this.products.findIndex(p => p.value == this.source.product_id)].label,
                        description: this.products[this.products.findIndex(p => p.value == this.source.product_id)].description_1,
                        pack_id: this.source.pack_id,
                        batch: this.source.batch,
                        expired_date: this.source.expired_date,
                        base_qty: this.source.base_qty,
                        base_uom_id: this.source.base_uom_id,
                        base_uom: this.products[this.products.findIndex(p => p.value == this.source.product_id)].base_uom.uom.name,
                        stock_type_id: this.source.stock_type_id,
                        stock_type: this.stock_types[this.stock_types.findIndex(s => s.value == this.source.stock_type_id)].label,
                    }

                    this.data.details.push(source)
                }

                if(!this.disableDestination.state) {

                    destination = {
                        line_id: line_id,
                        line_type: 'D',
                        warehouse_id: this.destination.warehouse_id,
                        warehouses_code: this.warehouses[this.warehouses.findIndex(w => w.value == this.destination.warehouse_id)].label,
                        client_id: this.destination.client_id,
                        client_code: this.clients[this.clients.findIndex(c => c.value == this.destination.client_id)].label,
                        product_id: this.destination.product_id,
                        product_code: this.products[this.products.findIndex(p => p.value == this.destination.product_id)].label,
                        description: this.products[this.products.findIndex(p => p.value == this.destination.product_id)].description_1,
                        pack_id: this.destination.pack_id,
                        batch: this.destination.batch,
                        expired_date: this.destination.expired_date,
                        base_qty: this.destination.base_qty,
                        base_uom_id: this.destination.base_uom_id,
                        base_uom: this.products[this.products.findIndex(p => p.value == this.destination.product_id)].base_uom.uom.name,
                        stock_type_id: this.destination.stock_type_id,
                        stock_type: this.stock_types[this.stock_types.findIndex(s => s.value == this.destination.stock_type_id)].label,
                    }


                    this.data.details.push(destination)
                }

                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: 'Line added successfully.'
                });
                this.showDetailPopup = false
                setTimeout(() => {
                    this.initShowDetail()
                }, 300)
            })
            .catch(error => this.handleError(error))
        },
        disableAll() {
            this.source = {
                warehouse_id: null,
                client_id: null,
                product_id: null,
                uom_id: null,
                base_uom_id: null,
                stock_type_id: null,
                description_1: '',
                description_2: '',
                pack_id: '',
                batch: '',
                expired_date: '',
                qty: '',
                base_qty: '',
                numerator: '',
                denominator: '',
                uoms: []
            }

            this.destination = {
                warehouse_id: null,
                client_id: null,
                product_id: null,
                uom_id: null,
                base_uom_id: null,
                stock_type_id: null,
                description_1: '',
                description_2: '',
                pack_id: '',
                batch: '',
                expired_date: '',
                qty: '',
                base_qty: '',
                numerator: '',
                denominator: '',
                uoms: []
            }

            this.disableDestination = {
                state: true,
                warehouse: true,
                client: true,
                product: true,
                pack_id: true,
                batch: true,
                expired_date: true,
                qty: true,
                uom: true,
                stock_type: true
            }

            this.disableSource = {
                state: true,
                warehouse: true,
                client: true,
                product: true,
                pack_id: true,
                batch: true,
                expired_date: true,
                qty: true,
                uom: true,
                stock_type: true
            }
        },
        generateLineId() {
            if(this.data.details.length < 1) {
                return 1
            }
            else {
                return this.data.details[this.data.details.length - 1].line_id + 1
            }
        },
        removeLine() {
            let indexes = []
            this.selected.map(item => {
                this.data.details.map((detail, index) => {
                    if(detail.line_id == item.line_id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)

            this.selected = []

            indexes.map(index => {
                this.data.details.splice(index, 1)
            })
        },
        handleTransactionTypeChange() {
            if(this.data.transaction_type_id) {
                this.data.transaction_description = this.transaction_types[this.transaction_types.findIndex(a => a.value === this.data.transaction_type_id)].description
            }
            else {
                this.data.transaction_description = ''
            }
        },
        searchWarehouse(search, loading) {
            // loading(true)
            // const data = {
            //     village: search
            // }
            // this.$http.post('master/areas', data)
            // .then(res => {
            //     res.data.data.map(item => {
            //     const index = this.area.findIndex(a => a.value == item.id)
            //     if(index === -1) {
            //         this.area.push({
            //         value: item.id,
            //         label: item.village
            //         })
            //     }
            //     })
            //     loading(false)
            // })
        },
        fetchDropdowns() {
            this.isLoading = true
            return Promise.all([
                this.$http.post('master/transactiontypes'),
                this.$http.post('master/warehouses'),
                this.$http.post('master/clients'),
                this.$http.post('master/stocktypes'),
            ])
            .then(this.$http.spread((transactiontypes, warehouses, clients, stocktypes) => {
                transactiontypes.data.data.map(transaction_type => {
                    this.transaction_types.push({ value: transaction_type.id, label: transaction_type.type, description: transaction_type.description })
                })

                warehouses.data.data.map(warehouse => {
                    this.warehouses.push({ value: warehouse.id, label: warehouse.warehouses_code })
                })

                clients.data.data.map(client => {
                    this.clients.push({ value: client.id, label: client.client_code })
                })

                stocktypes.data.data.map(stock_type => {
                    this.stock_types.push({ value: stock_type.id, label: stock_type.name })
                })
            }))
        },
        handleClientChange(client_id) {
            this.isLoading = true
            this.products = []
            this.$http.post('master/product/showbyclient', { client_id: client_id })
            .then(res => {
                res.data.data.map(item => {
                    const uoms = item.uoms.map(uom => {
                        return {
                            value: uom.uom_id,
                            label: uom.uom.name,
                            numerator: uom.numerator,
                            denominator: uom.denominator,
                        }
                    })
                    this.products.push({ value: item.id, label: item.product_code, description_1: item.description_1, description_2: item.description_2, base_uom: item.base_uom, uoms: uoms })
                })

                if(this.data.transaction_type_id == 3 || this.data.transaction_type_id == 4) {
                    this.destination.client_id = this.source.client_id
                }

                this.isLoading = false
            })
        },
        handleProductChange(value) {
            value.uoms = []

            if(value.product_id) {
                const data = this.products[this.products.findIndex(a => a.value === value.product_id)]
                value.description_1 = data.description_1
                value.description_2 = data.description_2
                value.uom_id = data.base_uom.uom_id
                value.base_uom_id = data.base_uom.uom_id
                value.uoms = data.uoms

                const uom = value.uoms[value.uoms.findIndex(a => a.value === value.uom_id)]
                value.numerator = uom.numerator
                value.denominator = uom.denominator

                value.base_qty = 1
                value.qty = 1

                if(this.data.transaction_type_id == 4 && value == this.source) {
                    this.destination.product_id = value.product_id
                    this.destination.description_1 = value.description_1
                    this.destination.description_2 = value.description_2
                    this.destination.uoms = value.uoms
                    this.destination.base_uom_id = value.base_uom_id
                    this.destination.uom_id = value.uom_id
                    this.destination.base_qty = value.base_qty
                    this.destination.qty = value.qty
                }
            }

        },
        handeUomChange(value) {
            if(value.uom_id) {
                const data = value.uoms[value.uoms.findIndex(a => a.value === value.uom_id)]
                value.numerator = data.numerator
                value.denominator = data.denominator

                if(this.data.transaction_type_id == 4) {
                    this.destination.uom_id = this.source.uom_id
                    this.destination.qty = this.source.qty
                    this.destination.base_qty = this.source.base_qty
                }
                
                this.convertQty(value)
            }

        },
        handleWarehouseChange() {
            if(this.data.transaction_type_id == 4 || this.data.transaction_type_id == 3) {
                this.destination.warehouse_id = this.source.warehouse_id
            }
        },
    },
    mounted() {
        this.fetchDropdowns().then(() => this.isLoading = false)
    },
};
</script>